import getFhirJson from "../../functions/getFhirJsonAPI";
import { m11ReportContainerResourceChanged, m11ReportSection01ResourceChanged, m11ReportSection02ResourceChanged, m11ReportSection03ResourceChanged, m11ReportSection04ResourceChanged, m11ReportSection05ResourceChanged, m11ReportSection06ResourceChanged, m11ReportSection07ResourceChanged, m11ReportSection08ResourceChanged, m11ReportSection09ResourceChanged, m11ReportSection10ResourceChanged, m11ReportSection11ResourceChanged, m11ReportSection12ResourceChanged, m11ReportSection13ResourceChanged, m11ReportSection14ResourceChanged } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";

const loadResource = async (foi, profile, apiToken, dispatch) => {
    let compositionJson = await getFhirJson(foi, null, apiToken);
    if (compositionJson) {
        switch (profile) {
            case "M11ReportContainer":
                dispatch(m11ReportContainerResourceChanged(compositionJson));
                break;
            case "M11ReportSection01":
                dispatch(m11ReportSection01ResourceChanged(compositionJson));
                break;
            case "M11ReportSection02":
                dispatch(m11ReportSection02ResourceChanged(compositionJson));
                break;
            case "M11ReportSection03":
                dispatch(m11ReportSection03ResourceChanged(compositionJson));
                break;
            case "M11ReportSection04":
                dispatch(m11ReportSection04ResourceChanged(compositionJson));
                break;
            case "M11ReportSection05":
                dispatch(m11ReportSection05ResourceChanged(compositionJson));
                break;
            case "M11ReportSection06":
                dispatch(m11ReportSection06ResourceChanged(compositionJson));
                break;
            case "M11ReportSection07":
                dispatch(m11ReportSection07ResourceChanged(compositionJson));
                break;
            case "M11ReportSection08":
                dispatch(m11ReportSection08ResourceChanged(compositionJson));
                break;
            case "M11ReportSection09":
                dispatch(m11ReportSection09ResourceChanged(compositionJson));
                break;
            case "M11ReportSection10":
                dispatch(m11ReportSection10ResourceChanged(compositionJson));
                break;
            case "M11ReportSection11":
                dispatch(m11ReportSection11ResourceChanged(compositionJson));
                break;
            case "M11ReportSection12":
                dispatch(m11ReportSection12ResourceChanged(compositionJson));
                break;
            case "M11ReportSection13":
                dispatch(m11ReportSection13ResourceChanged(compositionJson));
                break;
            case "M11ReportSection14":
                dispatch(m11ReportSection14ResourceChanged(compositionJson));
                break;
            default:
                alert("ERROR with profile sent to loadResource");
        }
    }
};

export default loadResource;